/**
 * The Library tab: the user's own texts (My Texts), and the means to add
 * more. Signed out, the route asks to sign in instead (app.ts).
 */
import * as preact from "preact";
import Button from "ui/Button";
import { PrivateLibrary } from "views/PrivateLibraryView";
import * as languagePage from "./languagePage";
import { shownAgain, type PreactPageProps } from "./PreactPage";

interface LibraryPageOptions {
  shelfID?: string;
  tag?: string;
}

const renderedCallback = () => {};

export default class LibraryPageView extends preact.Component<PreactPageProps> {
  private disposeLanguageWatch?: () => void;

  componentDidMount() {
    this.disposeLanguageWatch = languagePage.follow(this.props.appRouter);
    this.setTitle();
  }

  componentDidUpdate(previousProps: PreactPageProps) {
    // Back from another page (the tab kept as left)
    if (shownAgain(this.props, previousProps)) {
      this.setTitle();
    }
  }

  componentWillUnmount() {
    this.disposeLanguageWatch?.();
  }

  private setTitle() {
    localStorage.setItem("libraryOrDashboardPath", "/myTexts");
    languagePage.setTitle(
      "My Texts",
      (languageName) => `Your private bookshelf of ${languageName} texts.`
    );
  }

  private navigate = (path: string) => () =>
    this.props.appRouter.navigate(path, { trigger: true });

  render() {
    const { shelfID, tag } = this.props.options as LibraryPageOptions;
    return (
      <div class="library">
        <PrivateLibrary
          active={this.props.active}
          appRouter={this.props.appRouter}
          renderedCallback={renderedCallback}
          reselections={this.props.reselections}
          shelfID={shelfID}
          tag={tag}
          addButtons={
            // The tab names the page: no heading, but buttons saying what
            // they do (just their icons on tablets, leaving room to search)
            <div class="libraryButtons">
              <Button
                kind="primary"
                id="storyBot"
                icon="icon-magic"
                aria-label="Story Bot"
                onClick={this.navigate("/storyBot")}
              >
                <span class="buttonLabel">Story Bot</span>
              </Button>
              <Button
                kind="primary"
                id="addDocument"
                icon="icon-circle-arrow-up"
                aria-label="Upload"
                onClick={this.navigate("/upload")}
              >
                <span class="buttonLabel">Upload</span>
              </Button>
            </div>
          }
        />
      </div>
    );
  }
}
